<template>
  <section>
    <Title :title-name="title.TaxiCreditcard.titleName" :title-link="title.TaxiCreditcard.titleLink" />
    <div class="TaxiCreditcard">
      <div class="ServiceRefreshment">
        <div class="container" style="margin-top: 14pt">
          <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }} ,</p>
          <div>
            <p>You have chosen to make use of the taxi voucher with the maximum amount of {{ airline.currency_code }} 50,-.</p>
            <p>
              For your convenience we have created a credit card with a maximum amount of 50,-
              {{ airline.currency_code }} spending money, which you can use for payment during your taxi ride.
            </p>
            <p>Please read below details before you get into the Taxi.</p>
          </div>
        </div>
        <div class="container">
          <div class="block-item">
            <div class="container">
              <h2 class="title sb_mobile sb_creditcard" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
                Taxi
              </h2>
            </div>
          </div>
          <div class="container">
            <div class="block_div">
              <div class="content-section-wrap">
                <div class="description-wrap">
                  <p>
                    We have issued a {{ airline.currency_code }} 50,- creditcard for your convenience. This creditcard will be
                    valid until date {{ moment().format('DD-MM-YYYY') }} time 20:40. And it can be used for transportation
                    purposes like taxi. Please check with your taxi driver if he will accept creditcard as a form of payment
                    before you step into the Taxi.
                  </p>
                </div>
                <CreditCard></CreditCard>
              </div>
            </div>
          </div>
        </div>
        <div class="block-item">
          <div class="container">
            <router-link
              style="display: block; padding: 10pt 0; text-transform: uppercase"
              :to="{ name: 'VirtualCreditCardDetail', query: { secret: secret } }"
            >
              <div>
                <AboutCreditCard></AboutCreditCard>
              </div>
            </router-link>
          </div>
        </div>
        <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import AboutCreditCard from '@/components/AboutCreditCard/index'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import Title from '@/components/Title/index'

export default {
  name: 'TaxiCreditcard',
  components: { CreditCard, AboutCreditCard, ButtonDownloadVoucher, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Taxi',
      canDownload: false
    }
  },
  watch: {
    airline: function (newVal) {
      this.canDownload = newVal.currency_code != '' ? true : false
    }
  }
}
</script>
